import React from "react";
import { motion } from "framer-motion";
import { formatDate } from "../../utils/format";

export default function CampusCard({ campus, index = 0, onApply }) {
  return (
    <motion.article
      className="pm-campus-card"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.07, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
    >
      <div className="pm-campus-card__top">
        <span className="pm-campus-card__type">{campus.type_of_hire || "Hiring"}</span>
        <span className="pm-campus-card__dates">
          {formatDate(campus.start_date)} — {formatDate(campus.end_date)}
        </span>
      </div>
      <h3>{campus.name}</h3>
      <p className="pm-campus-card__location">{campus.location || "Location to be announced"}</p>
      <button className="pm-btn pm-btn--outline pm-btn--sm" onClick={() => onApply(campus)}>
        Apply to this campus →
      </button>
    </motion.article>
  );
}
